import { AxiosResponse } from 'axios';
import { apiClient } from 'services/restService';
import { createHeaderData } from 'utils/restUtils';
import { setAppErrorId } from 'features/app/appSlice';
import {
  ApplicationLogInterface,
  AuditLogInterface,
  BusinessTimeInterface
} from './appTypes';
import { AppThunk } from 'models/store';
import { HttpHeaders } from 'models';
import { Dispatch } from 'react';
import { logError } from 'services/Logging';

// ==============================|| APP THUNKS ||============================== //

export const fetchBusinessTime = async (): Promise<
  BusinessTimeInterface | undefined
> => {
  try {
    const response = await apiClient.get('/business-time');
    return response.data;
  } catch (error) {
    logError(error);
  }
};

export const sendApplicationLog =
  (appLog: ApplicationLogInterface | undefined): AppThunk =>
  (dispatch: Dispatch<ReturnType<typeof setAppErrorId>>) => {
    const headers: HttpHeaders = createHeaderData();

    apiClient
      .post('/appEvents/appLog', appLog, { headers })
      .then((_response: AxiosResponse) => {
        dispatch(setAppErrorId(headers['Transaction-Id']));
      })
      .catch((error) => {
        dispatch(setAppErrorId(undefined));
        logError(error);
      });
  };

export const sendAuditLog =
  (
    auditLog: AuditLogInterface | undefined,
    callback?: () => any | undefined
  ): AppThunk =>
  () => {
    apiClient
      .post('/appEvents/auditLog', auditLog, {
        headers: createHeaderData()
      })
      .then((_response: AxiosResponse) => {
        callback && callback();
      })
      .catch((error) => logError(error));
  };
